import { makeAutoObservable } from 'mobx'

export default class PageTemplateService {
  isSideNavigationOpen = false

  constructor() {
    makeAutoObservable(this)
  }

  setSideNavigationOpen(isOpen: boolean) {
    this.isSideNavigationOpen = isOpen
  }
}
